<template>
  <div
    v-if="activeDialog"
    class="overlay"
    :class="activeDialog ? 'active': ''"
  >
    <div class="common-dialog-wrapper">
      <div id="dialoge_close" class="close-dialog" @click="closePopups">
        <WhiteCloseIcon28 />
      </div>
      <div class="gallery-settings-wrapper">
        <h3>Gallery configuration</h3>
        <div class="file-type-select">
          <p>Select which file type to be uploaded</p>
          <div class="select-wrapper">
            <CustomCheckbox
              id="videos"
              label="Videos"
              :input-element="isVideoChecked"
            />
            <CustomCheckbox
              id="photos"
              label="Photos"
              :input-element="isPhotoChecked"
            />
          </div>
        </div>
        <div class="file-size-select">
          <p>Choose the size range for the files you want to upload:</p>
          <div class="size-select-wrapper">
            <div class="toggleWrapper">
              <input
                id="uploadCompact"
                v-model="sizeChosen"
                type="radio"
                name="uploadCompact"
                value="compact"
              >
              <label for="email-2fa" class="toggle">
                <div class="radio-label-wrapper">
                  <span class="toggle__handler">Compact</span>
                </div>
              </label>
            </div>
            <p>Upload only files up to 10Mb.</p>
            <div class="toggleWrapper">
              <input
                id="uploadAll"
                v-model="sizeChosen"
                type="radio"
                name="uploadAll"
                value="all"
              >
              <label for="sms-2fa" class="toggle">
                <div class="radio-label-wrapper">
                  <span class="toggle__handler">Everything</span>
                </div>
              </label>
            </div>
            <p>Upload all files</p>
          </div>
        </div>
      </div>
      <button
        id="dialoge_continue"
        class="btn dialog-btn"
        @click="saveData"
      >
        <span class="dialog-btn-text">Continue</span>
      </button>
    </div>
  </div>
</template>

<script>
import WhiteCloseIcon28 from '@/components/icons/WhiteCloseIcon28.vue';
import CustomCheckbox from '@/components/inputs/CustomCheckbox.vue';

export default {
  name: 'GalleryConfigPopup',
  components: {CustomCheckbox, WhiteCloseIcon28},
  props: {
    galleryConfig: {
      type: String,
      required: true,
    }
  },
  emits: ['closed', 'saveData'],
  data() {
    return {
      activeDialog: false,
      isVideoChecked: {isActive: false},
      isPhotoChecked: {isActive: false},
      sizeChosen: '',
    };
  },
  mounted() {
    const mappedGalleryConfig = this.stringToGalleryConfig(this.galleryConfig);
    this.isVideoChecked = mappedGalleryConfig.video;
    this.isPhotoChecked = mappedGalleryConfig.photo;
    this.sizeChosen = mappedGalleryConfig.size;
  },
  methods: {
    stringToGalleryConfig(galleryConfigString) {
      const values = galleryConfigString.split(',').map(item => item.trim());

      return {
        video: {isActive: values.includes('video')},
        photo: {isActive: values.includes('photo')},
        size: values.includes('compact') ? 'compact' : 'all',
      };
    },
    openPopups() {
      this.activeDialog = true;
    },
    closePopups() {
      this.activeDialog = false;
      this.$emit('closed');
    },
    saveData() {
      this.$emit('saveData', this.mapConfigToString());
      this.closePopups();
    },
    mapConfigToString() {
      const result = [];

      if (this.isVideoChecked.isActive === true) {
        result.push('video');
      }
      if (this.isPhotoChecked.isActive === true) {
        result.push('photo');
      }
      if (this.sizeChosen === 'compact') {
        result.push('compact');
      }

      return result.join(',');
    },
  }
};
</script>

<style scoped lang="scss">
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay.active {
  animation: show .3s linear;
}

.common-dialog-wrapper {
  width: 100%;
  max-width: 440px;
  border: 1px solid #D7DCE6;
  box-sizing: border-box;
  border-radius: 30px;
  padding: 40px 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
}

.close-dialog {
  width: 70px;
  height: 70px;
  padding: 23px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.close-dialog svg {
  width: 100%;
  height: 100%;
}

.close-dialog svg path {
  transition: .5s all;
}

.close-dialog:hover svg path {
  fill: var(--accent-color);
}

.close-dialog img {
  display: block;
  width: 100%;
}

.common-dialog-wrapper .dialog-btn {
  min-width: 140px;
  width: 100%;
  max-width: 215px;
  padding: 13px 12px;
  background-color: var(--white-color);
  border-color: var(--accent-color);
  border-radius: 25px;
  margin-top: 20px;
}

.common-dialog-wrapper .dialog-btn:hover {
  background-color: var(--accent-color);
  border-color: var(--accent-color);
}

.common-dialog-wrapper .dialog-btn:hover .dialog-btn-text {
  color: var(--white-color);
}

.dialog-btn-text {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: var(--accent-color);
  transition: .5s all;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  white-space: nowrap;
}

/*custom classes */
.common-dialog-wrapper.assign-success {
  width: 100%;
  max-width: 588px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.feedback-widget-icon {
  z-index: 1;
}

.gallery-settings-wrapper {
  max-width: 615px;
  width: 100%;
  max-height: 335px;
  height: 335px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  h3 {
    margin: 0;
    font-weight: 700;
    font-size: 30px;
    line-height: 100%;
    text-align: center;
    color: var(--secondary-black-color);
  }

  .file-type-select {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding-bottom: 10px;
    max-width: 266px;
    width: 100%;

    p {
      margin: 0;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      vertical-align: middle;
      color: var(--secondary-black-color);
    }

    .select-wrapper {
      display: flex;
      align-items: center;
      gap: 140px;
    }
  }

  .file-size-select {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 365px;
    width: 100%;

    p {
      margin: 0;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      vertical-align: middle;
      color: var(--secondary-black-color);
    }

    .size-select-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .toggleWrapper {
        display: flex;
        align-items: center;
        gap: 10px;

        .toggle {
          margin-bottom: 0;

          span {
            font-weight: 600;
            font-size: 14px;
            line-height: 100%;
            vertical-align: middle;
            color: var(--secondary-black-color);
          }
        }

        input {
          height: fit-content;
          margin: 2px 0 0;
        }

        input[type="radio"] {
          appearance: none;
          -webkit-appearance: none;
          width: 20px;
          height: 20px;
          border: 4px solid #EBEFF6;
          border-radius: 50%;
          position: relative;
          cursor: pointer;
          background-color: var(--white-color);
        }

        input[type="radio"]:checked::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background-color: var(--accent-color);
          border-radius: 50%;
        }
      }

      p {
        font-weight: 400;
        font-size: 14px;
        line-height: 100%;
        vertical-align: middle;
        color: var(--secondary-black-color);
        margin: 0 0 10px 30px;
        text-align: left;
      }
    }
  }
}
</style>
